import React from 'react';
import ReactDOM from 'react-dom';
import Root from './containers/Root';
import store, { history } from './Store';
// import registerServiceWorker from './registerServiceWorker';

export function startRoot() {
  ReactDOM.render(
    <Root store={store} history={history} />,
    document.getElementById('root')
  )
}
